import InitBookmark from 'front/shared/assets/scripts/initBookmark'

class TagHeader {
	initBookmark: InitBookmark

	constructor() {
		this.initBookmark = new InitBookmark()
	}

	init() {
		this.initBookmark.init()
	}
}

export default TagHeader
